(function () {
  'use strict';

  // Any change to the authoritative policy text leaves its original HTML untouched.
  const CURRENT_POLICY_FINGERPRINT = '16ccf283';
  const groups = [
    {
      headingIndex: 1,
      region: 'UK',
      clauses: [
        { number: 1, paragraphs: [2], title: 'Faulty or misdescribed goods' },
        { number: 2, paragraphs: [3, 4], title: 'Changing your mind' },
        { number: 3, paragraphs: [5], title: 'Letting us know' },
        { number: 4, paragraphs: [6], title: 'Inspection and refund' },
        { number: 5, paragraphs: [7], title: 'If your refund hasn’t arrived' },
        { number: 6, paragraphs: [8], title: 'Discount vouchers' },
        { number: 7, paragraphs: [9], title: 'Sale items' },
      ],
    },
    {
      headingIndex: 11,
      region: 'EU',
      clauses: [
        { number: 1, paragraphs: [12], title: 'Order cancellation' },
        { number: 2, paragraphs: [13], title: 'Faulty or misdescribed goods' },
        { number: 3, paragraphs: [14, 15], title: 'Changing your mind' },
        { number: 4, paragraphs: [16], title: 'Letting us know' },
        { number: 5, paragraphs: [17], title: 'Standard and express delivery costs' },
        { number: 6, paragraphs: [18], title: 'Customs duties' },
        { number: 7, paragraphs: [19], title: 'Inspection and refund' },
        { number: 8, paragraphs: [20], title: 'If your refund hasn’t arrived' },
        { number: 9, paragraphs: [21], title: 'Discount vouchers' },
      ],
    },
  ];

  function fingerprint(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16);
  }

  function normalizedText(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function enhanceRefundClauses(root, expectedFingerprint = CURRENT_POLICY_FINGERPRINT) {
    const wrapper = root.querySelector('.bb-policy--refund');
    const policy = wrapper?.querySelector('.shopify-policy__body .rte');
    if (!policy) return false;
    if (policy.dataset.bbPolicyClauses === 'enhanced') return true;
    const selectedRegion = wrapper.dataset.bbPolicyRegion === 'EU' ? 'EU' : 'UK';

    const paragraphs = Array.from(policy.children);
    if (paragraphs.length !== 24 || paragraphs.some((node) => node.tagName !== 'P')) return false;
    if (fingerprint(normalizedText(policy.textContent)) !== expectedFingerprint) return false;

    for (const group of groups) {
      const regionHeading = normalizedText(paragraphs[group.headingIndex].textContent);
      if (!regionHeading.includes(`Refund policy (${group.region})`)) return false;

      for (const clause of group.clauses) {
        const first = paragraphs[clause.paragraphs[0]].firstChild;
        const numberPattern = new RegExp(`^${clause.number}\\.[\\s\\u00a0]*`);
        if (first?.nodeType !== 3 || !numberPattern.test(first.textContent)) return false;
        if (clause.paragraphs.slice(1).some((index) => /^\d+\./.test(normalizedText(paragraphs[index].textContent)))) {
          return false;
        }
      }
    }

    for (const group of groups) {
      const list = root.createElement('ol');
      list.className = 'bb-policy__clause-list';
      list.setAttribute('aria-label', `${group.region} returns policy clauses`);
      policy.insertBefore(list, paragraphs[group.clauses[0].paragraphs[0]]);
      if (group.region !== selectedRegion) {
        paragraphs[group.headingIndex].hidden = true;
        list.hidden = true;
      }

      for (const clause of group.clauses) {
        const item = root.createElement('li');
        item.className = 'bb-policy__clause';

        const marker = root.createElement('span');
        marker.className = 'bb-policy__clause-number';
        marker.setAttribute('aria-hidden', 'true');
        marker.textContent = String(clause.number);

        const copy = root.createElement('div');
        copy.className = 'bb-policy__clause-copy';
        const title = root.createElement('h3');
        title.textContent = clause.title;
        copy.appendChild(title);

        const firstParagraph = paragraphs[clause.paragraphs[0]];
        const firstTextNode = firstParagraph.firstChild;
        const prefix = firstTextNode.textContent.match(new RegExp(`^${clause.number}\\.[\\s\\u00a0]*`))[0];
        firstTextNode.textContent = firstTextNode.textContent.slice(prefix.length);
        const originalNumber = root.createElement('span');
        originalNumber.className = 'bb-policy__original-number';
        originalNumber.setAttribute('aria-hidden', 'true');
        originalNumber.textContent = prefix;
        firstParagraph.insertBefore(originalNumber, firstTextNode);

        for (const index of clause.paragraphs) copy.appendChild(paragraphs[index]);
        item.append(marker, copy);
        list.appendChild(item);
      }
    }

    wrapper.querySelector('.bb-policy__summaries')?.removeAttribute('hidden');
    policy.dataset.bbPolicyClauses = 'enhanced';
    return true;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { enhanceRefundClauses, fingerprint, normalizedText };
  }
  if (typeof document !== 'undefined') enhanceRefundClauses(document);
})();
